<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
        <ValidationProvider
            rules="required"
            vid="warehouse_location"
            :name="$t('fields.warehouse_location').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.warehouse_location"
            :counter="30"
            :label="$t('fields.warehouse_location')"
            :error-messages="errors"
          ></v-text-field>

        </ValidationProvider>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { warehousesService } from '../../../utils/services/warehouses.service';

  export default {
    name: 'WarehouseModal',
    data() {
      return {
        stored: null,
        warehouse_product: {},
        form: {
          warehouse_id: null,
          product_id: null,
          warehouse_location: null,
        },
        loading: false,
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },

      async fetchProductInfo(warehouseId, productId) {
        return warehousesService.getProductInfo(warehouseId, productId)
        .then(response => {
            this.warehouse_product = response.data.data[0];
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },
    },
    async created() {
      this.loadingModal(true);
      if (this.data.stored.warehouse_id && this.data.stored.warehouse_id) {
        await this.fetchProductInfo(this.data.stored.warehouse_id, this.data.stored.product_id);
        this.form = {
          warehouse_id: this.data.stored.warehouse_id,
          product_id: this.data.stored.product_id,
          warehouse_location: this.warehouse_product.pivot.warehouse_location,

        };
      }
      this.loadingModal(false);
    },
  };
</script>
